import React from 'react'

import InfiniteScroll from "react-infinite-scroll-component";

import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

import {ProverbsData} from "./ProverbsData";

const Markov = require('js-markov')


let strings = new LocalizedStrings({
    en:{
        title:"proverbs",
        trainingData: ProverbsData.english(),
        description:"a collection of proverbs is analyzed and resynthesized by markov chains. the generated sentences are similar to known proverbs but not quite."
    },
    de: {
        title:"sprichwörter",
        trainingData: ProverbsData.german(),
        description:"eine sprichwörtersammlung wird mittels markov-ketten analysiert und resynthetisiert. die erzeugten sprüche ähneln so bekannten sprichwörtern."
    }
});

class Proverbs extends React.Component {
    constructor(props) {
        super(props)

        this.state = {texts: []}
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)

        if (this.state.texts.length === 0) {
            this.generate()
        }
    }

    componentWillReceiveProps(props) {
        const { language } = this.props;

        if (props.language !== language) {
            strings.setLanguage(props.language)

            this.generate()
        }
    }

    generate() {
        this.markov = new Markov()
        this.markov.addStates(strings.trainingData.split("\n"))
        this.markov.train(strings.getLanguage() === "en" ? 6 : 5)

        var texts = []
        for (var i = 0; i < 100; i++) {
            texts.push(this.markov.generateRandom(500))
        }

        this.setState({texts: texts})
    }

    fetchMoreData = () => {
        var texts = []
        for (var i = 0; i < 10; i++) {
            texts.push(this.markov.generateRandom(500))
        }

        this.setState({
            texts: this.state.texts.concat(texts)
        });
    };

    render() {
        strings.setLanguage(this.context.language)
        return <div className="poemDisplay">
            <InfiniteScroll
                dataLength={this.state.texts.length}
                next={this.fetchMoreData}
                hasMore={true}
                loader={<h4>Loading...</h4>}
            >
                {this.state.texts.map((text, index) => (
                    <p key={index}>
                        {text}
                    </p>
                ))}
            </InfiniteScroll>
        </div>
    }
}
Proverbs.contextType = LanguageContext

export default Proverbs
